import { PERMISSIONS } from "@/constants";

export default [
    {
        name: "monthlydata",
        meta: {
            title: "Monthly Numbers",
            requiresAuth: true,
            permission_scopes: [PERMISSIONS.ANALYTICS_ALL],
        },
        path: "/manage/monthlydata",
        component: () => import("@/views/pages/monthlynumbers/index.vue"),
    }
]